import BtnSimpl from '../../components/buttons/BtnSimpl';
import { Col, Form, Input, Row, Spin,  } from 'antd';
import Title from 'antd/es/typography/Title';
import logoUniversite from "../../assets/img/logo-ussd-1.jpg";
import "./auth.css";
import { useState } from 'react';
import ModalComponent from '../../components/modals/ModalComponent';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../../redux/actions/LoginActions';
import { forgotPassword } from '../../redux/actions/ForgotPasswordActions';


const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
     const [openModal, setOpenModal] = useState();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();


       const handleOpenModal = () => {
        setOpenModal(true);
        };
       const handleCloseModal = () => {
        setOpenModal(false);
        form.resetFields();
       }
       const { loading:loadingAuth, error } = useSelector((state) => state.auth); 

    const handleLogin = async (values) => {
        try {
            await dispatch(loginUser(values));
            navigate("/dashboard");
        } catch (error) {
        }
    };

    const { loading:loadingForgotP, } = useSelector(state => state.forgotPassword);

       const handleSubmitForgotPassword = async (values) => {
       
        try {
           const response = await dispatch(forgotPassword(values));
                if (response) {
                     handleCloseModal();
                }
    
        } catch (err) {
        }
    };

    return (
                <Row justify="center" className='divGlobal'>
                    <Col span={10} className='colGlobal'>
                    
                        <img style={{width:"27%", height:"25%" , marginBottom:"-4.5%", marginTop:""}} src={logoUniversite} alt="logoussd" />
                        <Title level={1}>Connexion</Title>

                        <Form onFinish={handleLogin}>
                            <Form.Item name="username"  rules={[{ required: true, message: "Champ obligatoire" }]} >
                                <Input value = {username} placeholder="Nom d'utilisateur"  style={{padding:"3%", fontSize:"18px", }} />
                            </Form.Item>

                            <Form.Item name="password"  rules={[{ required: true, message: 'Champ obligatoire' }]} >
                                <Input.Password value = {password} placeholder="Mot de passe" style={{padding:"3%", fontSize:"18px", marginTop:"-1%"}} />
                            </Form.Item>
                            {error && <p style={{ color: "red", textAlign:"left", marginTop:"-3.5%" }}>{error}</p>}

                            <Form.Item  style={{marginTop:"-6%", marginBottom:0 }} >
                               <p onClick={handleOpenModal} style={{color:"#43CE0C", cursor:"pointer", float:"left"}}>Mot de passe oublié</p>
                            </Form.Item>
                           
                            <Form.Item>
                              {/* <Spin className="spinLoading" spinning={loadingAuth} tip="Connexion en cours..." size="small"> */}
                            <BtnSimpl buttonText_={loadingAuth ? "Connexion en cours..." : "Se connecter"}  backgroundColor_="#43CE0C" 
                            width_="100%" padding_="7.2%"  htmlType_="submit" borderRadius_="0.5rem" border_={true}
                            color_="#ffffff" boldColor_={600} fontSize_="18px" 
                            disabled_= {loadingAuth} 
                            />
                            {/* </Spin> */}
                            </Form.Item>

                         </Form>
                    </Col>
                    {/* Les MODALS */}
            <div style={{width:"100%"}}>
                    <ModalComponent  
                        _title={<h4 style={{marginTop:"-1%"}}>Veuillez saisir votre adresse email</h4>}
                        _width="32%"
                        _padding="0"
                        _maskClosable={false}
                        _closable={true} 
                        _open={openModal}
                        _onCancel={handleCloseModal}
                        _form={ 
                           <Form form={form} onFinish={handleSubmitForgotPassword}>
                                <Form.Item style={{marginTop:"",}} name="email"  rules={[{ required: true, message: "L'adresse email est obligatoire" }, { type: "email", message: "L'adresse email n'est pas valide" }, ]} >
                                    <Input value = {email}  placeholder="Veuillez saisir votre adresse email"  style={{padding:"3%", fontSize:"", }} />
                                </Form.Item>

                                <Form.Item style={{marginBottom:3}}>
                                     <Spin className="spinLoading" style={{marginLeft:"33%", marginTop:"6%"}} spinning={loadingForgotP} tip="Envoie en cours..." size="large">
                                    <BtnSimpl buttonText_="Envoyer"  backgroundColor_="#43CE0C" float_="right"
                                      htmlType_="submit" borderRadius_="0.5rem" width_="30%"
                                    color_="#ffffff" boldColor_={600} 
                                    disabled_= {loadingForgotP} 
                                    />
                                     </Spin>
                                    </Form.Item>
                           </Form>
                        }
                    />
                </div>
                </Row>
    );
};

export default Login;